import React, { createContext, useContext, useMemo } from 'react';
import { ArrayParam, useQueryParams } from 'use-query-params';
import { useCurrentShop } from '../../Dashboard/hooks/useCurrentShop';
const ExperimentsContext = createContext([]);
export const ExperimentsProvider = ({ children }) => {
    const { currentShop } = useCurrentShop();
    const [{ experiment }] = useQueryParams({ experiment: ArrayParam });
    const activeExperiments = useMemo(() => {
        const activeExperimentForced = experiment;
        if (activeExperimentForced) {
            return activeExperimentForced;
        }
        if (!currentShop)
            return [];
        return currentShop.activeExperiments;
    }, [currentShop, experiment]);
    return (React.createElement(ExperimentsContext.Provider, { value: activeExperiments }, children));
};
export const useExperiments = () => {
    const context = useContext(ExperimentsContext);
    if (context === undefined) {
        throw new Error('useExperiments must be used within an ExperimentsProvider');
    }
    return context;
};
